
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import { $delay } from '@/common/utils';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import SPUService from '@/services/spu.service';

@Component
export default class ProductImageModal extends Vue {
  visible = false;

  @lazyInject(UserService)
  protected userService!: UserService;

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Prop({ default: () => [] })
  categoryPhotoList!: any;

  BASE_URL = BASE_URL;

  token: string | undefined = undefined;

  form: any = {
    cate_id: '',
    photo_type_id: 1, // 图片分类 Id 必传
    photo_id: '2', // 图片Id 必传
    // 下面字段 修改哪个传哪个
    photo_name: '修改图片名称test',
    is_default: '0',
    is_del: 0,
    status: 0,
  };

  defaultList = [
    {
      label: 1,
      value: '是',
    },
    {
      label: 0,
      value: '否',
    },
  ];
  statusList = [
    {
      label: 1,
      value: '启用',
    },
    {
      label: 0,
      value: '禁用',
    },
  ];

  rules: any = {
    photo_type_name: [
      { required: true, message: '请输入图片分类名称', trigger: 'blur' },
    ],
  };

  labelCol = { span: 6 };

  wrapperCol = { span: 12 };

  init(item: any) {
    this.form = JSON.parse(JSON.stringify(item));
    this.visible = true;
  }

  async handleOk() {
    const res = await this.spuService.postCategoryPhotoEditPhoto(this.form);
    if (res) {
      this.$message.success('修改成功');
      this.$emit('upload');
      this.visible = false;
    }
  }

  handleCancel() {
    this.visible = false;
  }

  async onChangeImg(info: any) {
    // console.log(info);
    if (info.file.status === 'error') {
      const { code, error } = info.file.response;
      if (code === 400) {
        this.$message.error(error);
        await $delay(1000);
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        });
      } else {
        this.$message.error(error);
      }
    }
    if (info.file.status === 'done') {
      const { data } = JSON.parse(info.file.xhr.response);
      const headlineImage = {
        id: data[0]?.id,
        uid: data[0]?.id,
        url: data[0]?.url,
        name: 'mage.png',
        status: 'done',
      };
      // console.log(headlineImage);
      this.form.resource_id = headlineImage.id;
      this.form.url = headlineImage.url;
    }
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }

  created() {
    this.token = this.userService.currentUser()?.token;
  }
}
